import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import type { PageEvent } from '@angular/material/paginator';
import { MatPaginator } from '@angular/material/paginator';
import { Store } from '@ngxs/store';
import { ChangePaginationAction } from '../state/action/change-pagination.action';
import { provideMatPaginatorIntl } from './config/provide-mat-paginator.intl';
import type { Pagination } from '../data/table-data-source';

@Component({
  selector: 'pct-feature-table-material-table-paginator',
  imports: [MatPaginator],
  templateUrl: './table-paginator.component.html',
  providers: [provideMatPaginatorIntl()],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TablePaginatorComponent {
  readonly #store = inject(Store);

  readonly tableId = input.required<string>();
  readonly sizeOptions = input([10, 20, 50, 100]);
  readonly pagination = input.required<Pagination>();

  protected emitPagination({ pageIndex, pageSize }: PageEvent): void {
    this.#store.dispatch(
      new ChangePaginationAction({
        tableId: this.tableId(),
        page: pageIndex + 1,
        size: pageSize,
      }),
    );
  }
}
